import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TPVServices } from "../services";
import { Globals } from "../../../globals";
import { TakeawayServices } from '../../takeaway/services';
import { ConfigurationRestWebPage } from '../../configuration/configuration-rest-web/configuration-rest-web';


/**
 * Generated class for the TpvHoraryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-horary',
  templateUrl: 'tpv-horary.html',
})
export class TpvHoraryPage {


  first_enter: boolean = true;

  constructor(public globals: Globals,
    public tpvServices: TPVServices,
    public takeawayServices: TakeawayServices,
    public navCtrl: NavController,
    public navParams: NavParams) {

  }

  getDeliveryImage(table) {
    if (table != undefined) {
      const delivery = this.takeawayServices.deliveries.find(t => t.name == table);
      if (delivery != undefined) {
        return delivery.img;
      }
    }
  }

  changeArrow(hour) {
    var arrow = document.getElementById(hour.uid + "_arrow");
    if (hour.arrow == undefined || hour.arrow) {
      arrow.classList.remove("mdi-arrow-down");
      arrow.classList.add('mdi-arrow-up');
      hour.arrow = false;
    } else {
      arrow.classList.remove("mdi-arrow-up");
      arrow.classList.add('mdi-arrow-down');
      hour.arrow = true;
    }
  }

  openConfig() {
    this.navCtrl.push(ConfigurationRestWebPage, {
      config_horary: true
    });
  }

  async scrollAndMark(order) {
    //prepare id
    var id = "tk-" + order.UID;
    //scroll
    document.getElementById(id).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    //animation
    var element_tk = document.getElementById(id);
    element_tk.classList.remove("flashit");
    await this.globals.delay(100);
    element_tk.classList.add("flashit");
  }



}


// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-horary/tpv-horary.ts